import { route } from '@/ziggy-shim';
import { api, apiConfig, CastValue } from './LaravelClient';

export default {
  async store(
    claimId: Id,
    tradeItemId: Id,
    data: ApiRequests['api.v1.subcontractor.claims.lite.rates.store'],
  ) {
    return await api(
      route('api.v1.subcontractor.claims.lite.rates.store', [claimId, tradeItemId]),
      'post',
      {
        data,
        casts: {
          current_quantity: (value, clone, key) => new CastValue(value).cast('nullable', clone, key).get(),
          current_certified: (value, clone, key) => new CastValue(value).cast('nullable', clone, key).get(),
          comment: (value, clone, key) => new CastValue(value).cast('nullable', clone, key).get(),
        },
      },
    );
  },

  async update(id: Id, data: ApiRequests['api.v1.rates-costs.update']) {
    return await api(
      route('api.v1.rates-costs.update', id),
      'patch',
      {
        data,
        casts: {
          current_quantity: (value, clone, key) => new CastValue(value).cast('nullable', clone, key).get(),
          current_certified: (value, clone, key) => new CastValue(value).cast('nullable', clone, key).get(),
          comment: (value, clone, key) => new CastValue(value).cast('nullable', clone, key).get(),
        },
      },
    );
  },

  async storeComment(id: Id, data: ApiRequests['api.v1.rates-costs.comments.store']) {
    return await api(route('api.v1.rates-costs.comments.store', id), 'post', {
      data,
    });
  },

  async updateComment(ratesCostId: Id, commentId: Id, data: ApiRequests['api.v1.rates-costs.comments.update']) {
    return await api(route('api.v1.rates-costs.comments.update', [ratesCostId, commentId]), 'patch', {
      data,
    });
  },

  async deleteComment(ratesCostId: Id, commentId: Id) {
    return await api(route('api.v1.rates-costs.comments.destroy', [ratesCostId, commentId]), 'delete');
  },

  async destroy(id: Id) {
    return await api(route('api.v1.rates-costs.destroy', id), 'delete');
  },

  subcontractor: {
    async store(
      claimId: Id,
      signedParams: unknown,
      data: ApiRequests['api.v1.subcontractor.claims.rates.claim.store'],
    ) {
      console.log(signedParams);

      return await apiConfig(route('api.v1.subcontractor.claims.rates.claim.store', claimId), 'post', {
        params: signedParams,
        paramsSerializer: {
          serialize: (params) => {
            return new URLSearchParams(params).toString();
          },
        },
      }, {
        data,
      });
    },

    async destroy(
      claimId: Id,
      signedParams: unknown,
      data: ApiRequests['api.v1.subcontractor.claims.rates.claim.destroy'],
    ) {
      return await apiConfig(route('api.v1.subcontractor.claims.rates.claim.destroy', claimId), 'delete', {
        params: signedParams,
        paramsSerializer: {
          serialize: (params) => {
            return new URLSearchParams(params).toString();
          },
        },
      }, {
        data,
      });
    },

    async storeCertified(
      projectId: Id,
      claimId: Id,
      id: Id,
      data: ApiRequests['api.v1.subcontractor.claims.rates.certified.store'],
    ) {
      return await api(
        route('api.v1.subcontractor.claims.rates.certified.store', [projectId, claimId, id]),
        'post',
        {
          data,
          casts: {
            comment_trade: (value, clone, key) => new CastValue(value).cast('nullable', clone, key).get(),
          },
        },
      );
    },
  },
};
